// extracted by mini-css-extract-plugin
module.exports = {"margin-for-arrows":"SlickExtend_margin-for-arrows___GvbG","root":"SlickExtend_root__CESjK"};